{{#if pages.length }}
<div class="center">
  <div class="pagination">
    {{#ifGreater currentPage 1}}
    <a href="#" class="paginator-button paginator-prev-button" data-val="{{add currentPage -1}}">&laquo;</a>
    {{/ifGreater}}

    {{#each pages}}
    {{#ifEquals this "spacer"}}
    <span class="no-click">...</span>
    {{else}}
    <a href="#" class="paginator-button paginator-page-button{{#ifEquals ../currentPage this}} active{{/ifEquals}}" data-val="{{this}}">{{this}}</a>
    {{/ifEquals}}
    {{/each}}

    {{#ifLess currentPage numPages}}
    <a href="#" class="paginator-button paginator-next-button" data-val="{{add currentPage 1}}">&raquo;</a>
    {{/ifLess}}
  </div>
</div>
{{/if}}